import { Loader2 } from "lucide-react";
import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";

import { landingPathFor } from "@/config/navigation";
import { useMe } from "@/features/auth/hooks";
import { useAuthStore } from "@/features/auth/store";

/**
 * Garde de la page Statistiques : redirige l'utilisateur dont le rôle n'est
 * pas autorisé à la voir (réglage abonné « statistiques par rôle », résolu
 * côté back dans `active_display_config.hidden_nav`) vers sa page
 * d'atterrissage. Sans réglage, la page reste visible par tous. Calqué sur
 * DashboardGuard.
 */
export function StatisticsGuard({ children }: { children: ReactNode }) {
  const meQuery = useMe();
  const storeMe = useAuthStore((s) => s.me);
  const me = meQuery.data ?? storeMe;

  if (meQuery.isLoading && !storeMe) {
    return (
      <div className="flex h-64 items-center justify-center">
        <Loader2 className="h-6 w-6 animate-spin text-primary" />
      </div>
    );
  }

  const hidden = new Set(me?.active_display_config?.hidden_nav ?? []).has("/statistiques");
  if (hidden) {
    return <Navigate to={landingPathFor(me)} replace />;
  }
  return <>{children}</>;
}
